module.exports = {"230671010":"开发区黎明街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230671.json
// module id = 740
// module chunks = 0